import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { saveEmailToSupabase } from '../services/emailService'

const Footer = () => {
  const [isSubmittingMobile, setIsSubmittingMobile] = useState(false)
  const [isSubmittingDesktop, setIsSubmittingDesktop] = useState(false)
  const [emailErrorMobile, setEmailErrorMobile] = useState('')
  const [emailErrorDesktop, setEmailErrorDesktop] = useState('')
  const [saveSuccessMobile, setSaveSuccessMobile] = useState(false)
  const [saveSuccessDesktop, setSaveSuccessDesktop] = useState(false)
  return (
    <footer className='bg-surface text-text-primary border-t border-border pt-10 pb-10'>
      {/* Mobile Footer */}
      <div className='md:hidden'>
        <div className='flex items-center justify-start mb-6 w-full px-4'>
          <Link to='/' className='flex items-center'>
            <div className='bg-primary rounded-full p-2 mr-2 border-2 border-border'>
              <img
                src='/favicon/android-chrome-192x192.png'
                alt='Logo'
                className='w-6 h-6'
              />
            </div>
            <span className='font-bold text-primary'>Conversor IAE CNAE</span>
          </Link>
        </div>
        <div className='container mx-auto px-4 py-6'>
          {/* Description */}
          <div className='mb-6'>
            <p className='text-sm justify-start'>
              Conversor de Códigos IAE y CNAE para Autónomos y Empresas
            </p>
          </div>

          {/* Social Icons */}
          <div className='flex justify-start space-x-4 mb-6'>
            <a
              href='https://www.youtube.com/@conversoriaecnae-es'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src='/resources/icons/youtube.png'
                alt='YouTube'
                className='w-8 h-8 object-contain'
              />
            </a>
            <a
              href='https://www.reddit.com/r/ConversorIAE_CNAE/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src='/resources/icons/reddit.png'
                alt='Reddit'
                className='w-8 h-8 object-contain'
              />
            </a>
            <a
              href='https://www.instagram.com/conversoriaecnae/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src='/resources/icons/instagram.png'
                alt='Instagram'
                className='w-8 h-8 object-contain'
              />
            </a>
            <a
              href='https://www.facebook.com/profile.php?id=61572532213165'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src='/resources/icons/facebook.png'
                alt='Facebook'
                className='w-8 h-8 object-contain'
              />
            </a>
            <a
              href='https://www.threads.net/@conversoriaecnae?hl=es'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src='/resources/icons/thread.png'
                alt='Threads'
                className='w-8 h-8 object-contain'
              />
            </a>
          </div>

          {/* Divider */}
          <div className='border-t border-border my-6'></div>

          {/* Newsletter */}
          <div className='mb-6'>
            <p className='text-lg font-semibold mb-4 text-start text-white'>
              Suscríbete al boletín
            </p>
            <form
              onSubmit={async (e) => {
                e.preventDefault()
                setEmailErrorMobile('')
                setSaveSuccessMobile(false)

                const email = e.target.email.value
                const termsAccepted = e.target.terms.checked

                // Validate email format
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!emailRegex.test(email)) {
                  setEmailErrorMobile('Por favor, introduce un email válido')
                  return
                }

                if (email && termsAccepted) {
                  setIsSubmittingMobile(true)

                  try {
                    // Save email to Supabase
                    const result = await saveEmailToSupabase(email)

                    if (result.success) {
                      setSaveSuccessMobile(true)
                      // Redirect to Substack without email parameter
                      window.location.href =
                        'https://conversoriaecnae.substack.com/embed'
                    } else {
                      setEmailErrorMobile(
                        'Error al guardar el email. Por favor, inténtalo de nuevo.'
                      )
                      setIsSubmittingMobile(false)
                    }
                  } catch (error) {
                    console.error('Error in form submission:', error)
                    setEmailErrorMobile(
                      'Error al procesar la solicitud. Por favor, inténtalo de nuevo.'
                    )
                    setIsSubmittingMobile(false)
                  }
                }
              }}
            >
              <div className='mb-3'>
                <input
                  type='email'
                  name='email'
                  placeholder='Email'
                  className={`w-full p-3 border-2 border-dashed ${
                    emailErrorMobile ? 'border-red-500' : 'border-border'
                  } rounded bg-transparent text-text-primary`}
                  required
                />
                {emailErrorMobile && (
                  <p className='text-red-500 text-sm mt-1'>
                    {emailErrorMobile}
                  </p>
                )}
                {saveSuccessMobile && (
                  <p className='text-green-500 text-sm mt-1'>
                    Email guardado correctamente
                  </p>
                )}
              </div>
              <div className='flex items-center mb-4'>
                <input
                  type='checkbox'
                  id='terms-mobile'
                  name='terms'
                  className='mr-2'
                  required
                />
                <label htmlFor='terms-mobile' className='text-sm text-white'>
                  Estoy de acuerdo con los{' '}
                  <Link to='/terminos-condiciones' className='text-primary'>
                    Términos & condiciones
                  </Link>
                </label>
              </div>
              <button
                type='submit'
                className='w-full bg-primary text-background py-3 rounded font-medium'
                disabled={isSubmittingMobile}
              >
                {isSubmittingMobile ? 'Procesando...' : 'Suscribirme'}
              </button>
            </form>
          </div>

          {/* Divider */}
          <div className='border-t border-border my-6'></div>

          {/* Pages */}
          <div className='mb-6'>
            <p className='text-lg font-semibold mb-4 text-white'>Páginas</p>
            <ul className='space-y-2'>
              <li>
                <Link
                  to='/'
                  className='text-white hover:text-primary transition-colors'
                >
                  Conversor
                </Link>
              </li>
              <li>
                <Link
                  to='/epigrafes-iae/'
                  className='text-white hover:text-primary transition-colors'
                >
                  Epígrafes IAE
                </Link>
              </li>
              <li>
                <Link
                  to='/codigos-cnae/'
                  className='text-white hover:text-primary transition-colors'
                >
                  Códigos CNAE 2025
                </Link>
              </li>
              <li>
                <Link
                  to='/codigos-cnae-2009/'
                  className='text-white hover:text-primary transition-colors'
                >
                  Códigos CNAE 2009
                </Link>
              </li>
              <li>
                <Link
                  to='/correspondencia-entre-codigos-cnae-2025-cnae-2009/'
                  className='text-white hover:text-primary transition-colors'
                >
                  Correspondencias CNAE
                </Link>
              </li>
              <li>
                <a
                  href='https://www.reddit.com/r/ConversorIAE_CNAE/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-white hover:text-primary transition-colors'
                >
                  Comunidad
                </a>
              </li>
              <li>
                <Link
                  to='/newsletter/'
                  className='text-white hover:text-primary transition-colors'
                >
                  Newsletter
                </Link>
              </li>
              <li>
                <a
                  href='https://api.conversoriaecnae.es'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-white hover:text-primary transition-colors flex items-center'
                >
                  API para Desarrolladores
                  <span className='ml-2 text-xs'>↗</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Divider */}
          <div className='border-t border-border my-6'></div>

          {/* Copyright and Legal */}
          <div className='text-sm'>
            <p className='mb-4 text-white'>
              ©{new Date().getFullYear()}. Todos los derechos reservados
            </p>
            <div className='space-y-2'>
              <div>
                <Link to='/cookies-config' className='text-white underline'>
                  Configuración Cookies
                </Link>
              </div>
              <div>
                <Link
                  to='/terminos-condiciones'
                  className='text-white underline'
                >
                  Términos & Condiciones
                </Link>
              </div>
              <div>
                <Link
                  to='/politica-privacidad'
                  className='text-white underline'
                >
                  Política de Privacidad
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Footer */}
      <div className='hidden md:block'>
        <div className='container mx-auto px-4 py-8'>
          <div className='grid grid-cols-12 gap-8'>
            {/* Logo and Social */}
            <div className='col-span-4'>
              <div className='flex items-center mb-6'>
                <Link to='/' className='flex items-center'>
                  <div className='bg-primary rounded-full p-2 mr-2 border-2 border-border'>
                    <img
                      src='/favicon/android-chrome-512x512.png'
                      alt='Logo'
                      className='w-6 h-6'
                    />
                  </div>
                  <span className='font-semibold text-primary'>
                    Conversor IAE CNAE
                  </span>
                </Link>
              </div>
              <p className='text-sm mb-4'>
                Conversor de Códigos IAE y CNAE para Autónomos y Empresas
              </p>
              <div className='flex space-x-3 mt-4'>
                <a
                  href='https://www.youtube.com/@conversoriaecnae-es'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='border border-transparent rounded-full p-2 hover:border-primary'
                >
                  <img
                    src='/resources/icons/youtube.png'
                    alt='YouTube'
                    className='w-7 h-7 object-contain'
                  />
                </a>
                <a
                  href='https://www.reddit.com/r/ConversorIAE_CNAE/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='border border-transparent rounded-full p-2 hover:border-primary'
                >
                  <img
                    src='/resources/icons/reddit.png'
                    alt='Reddit'
                    className='w-7 h-7 object-contain'
                  />
                </a>
                <a
                  href='https://www.instagram.com/conversoriaecnae/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='border border-transparent rounded-full p-2 hover:border-primary'
                >
                  <img
                    src='/resources/icons/instagram.png'
                    alt='Instagram'
                    className='w-7 h-7 object-contain'
                  />
                </a>
                <a
                  href='https://www.facebook.com/profile.php?id=61572532213165'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='border border-transparent rounded-full p-2 hover:border-primary'
                >
                  <img
                    src='/resources/icons/facebook.png'
                    alt='Facebook'
                    className='w-7 h-7 object-contain'
                  />
                </a>
                <a
                  href='https://www.threads.net/@conversoriaecnae?hl=es'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='border border-transparent rounded-full p-2 hover:border-primary'
                >
                  <img
                    src='/resources/icons/thread.png'
                    alt='Threads'
                    className='w-7 h-7 object-contain'
                  />
                </a>
              </div>
            </div>

            {/* Pages */}
            <div className='col-span-3'>
              <p className='text-lg font-semibold mb-4 text-white'>Páginas</p>
              <ul className='space-y-2'>
                <li>
                  <Link
                    to='/'
                    className='text-white hover:text-primary transition-colors'
                  >
                    Conversor
                  </Link>
                </li>
                <li>
                  <Link
                    to='/epigrafes-iae/'
                    className='text-white hover:text-primary transition-colors'
                  >
                    Epígrafes IAE
                  </Link>
                </li>
                <li>
                  <Link
                    to='/codigos-cnae/'
                    className='text-white hover:text-primary transition-colors'
                  >
                    Códigos CNAE 2025
                  </Link>
                </li>
                <li>
                  <Link
                    to='/codigos-cnae-2009/'
                    className='text-white hover:text-primary transition-colors'
                  >
                    Códigos CNAE 2009
                  </Link>
                </li>
                <li>
                  <Link
                    to='/correspondencia-entre-codigos-cnae-2025-cnae-2009/'
                    className='text-white hover:text-primary transition-colors'
                  >
                    Correspondencias CNAE
                  </Link>
                </li>
                <li>
                  <a
                    href='https://www.reddit.com/r/ConversorIAE_CNAE/'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white hover:text-primary transition-colors'
                  >
                    Comunidad
                  </a>
                </li>
                <li>
                  <Link
                    to='/newsletter/'
                    className='text-white hover:text-primary transition-colors'
                  >
                    Newsletter
                  </Link>
                </li>
                <li>
                  <a
                    href='https://api.conversoriaecnae.es'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white hover:text-primary transition-colors flex items-center'
                  >
                    API para Desarrolladores
                    <span className='ml-2 text-xs'>↗</span>
                  </a>
                </li>
              </ul>
            </div>

            {/* Newsletter */}
            <div className='col-span-5'>
              <p className='text-lg font-semibold mb-4 text-white'>
                Suscríbete al boletín
              </p>
              <form
                onSubmit={async (e) => {
                  e.preventDefault()
                  setEmailErrorDesktop('')
                  setSaveSuccessDesktop(false)

                  const email = e.target.email.value
                  const termsAccepted = e.target.terms.checked

                  // Validate email format
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                  if (!emailRegex.test(email)) {
                    setEmailErrorDesktop('Por favor, introduce un email válido')
                    return
                  }

                  if (email && termsAccepted) {
                    setIsSubmittingDesktop(true)

                    try {
                      // Save email to Supabase
                      const result = await saveEmailToSupabase(email)

                      if (result.success) {
                        setSaveSuccessDesktop(true)
                        // Redirect to Substack without email parameter
                        window.location.href =
                          'https://conversoriaecnae.substack.com/embed'
                      } else {
                        setEmailErrorDesktop(
                          'Error al guardar el email. Por favor, inténtalo de nuevo.'
                        )
                        setIsSubmittingDesktop(false)
                      }
                    } catch (error) {
                      console.error('Error in form submission:', error)
                      setEmailErrorDesktop(
                        'Error al procesar la solicitud. Por favor, inténtalo de nuevo.'
                      )
                      setIsSubmittingDesktop(false)
                    }
                  }
                }}
              >
                <div className='mb-3'>
                  <input
                    type='email'
                    name='email'
                    placeholder='Email'
                    className={`w-full p-3 border-2 border-dashed ${
                      emailErrorDesktop ? 'border-red-500' : 'border-border'
                    } rounded bg-transparent text-text-primary`}
                    required
                  />
                  {emailErrorDesktop && (
                    <p className='text-red-500 text-sm mt-1'>
                      {emailErrorDesktop}
                    </p>
                  )}
                  {saveSuccessDesktop && (
                    <p className='text-green-500 text-sm mt-1'>
                      Email guardado correctamente
                    </p>
                  )}
                </div>
                <div className='flex items-center mb-4'>
                  <input
                    type='checkbox'
                    id='terms-desktop'
                    name='terms'
                    className='mr-2'
                    required
                  />
                  <label htmlFor='terms-desktop' className='text-sm text-white'>
                    Estoy de acuerdo con los{' '}
                    <Link to='/terminos-condiciones' className='text-primary'>
                      Términos & Condiciones
                    </Link>
                  </label>
                </div>
                <button
                  type='submit'
                  className='bg-primary text-background px-6 py-3 rounded font-medium'
                  disabled={isSubmittingDesktop}
                >
                  {isSubmittingDesktop ? 'Procesando...' : 'Suscribirme'}
                </button>
              </form>
            </div>
          </div>

          {/* Divider */}
          <div className='border-t border-border my-8'></div>

          {/* Copyright and Legal */}
          <div className='flex flex-wrap justify-between items-center'>
            <div className='text-sm text-white'>
              ©{new Date().getFullYear()}. Todos los derechos reservados
            </div>
            <div className='flex space-x-6 text-sm'>
              <Link
                to='/cookies-configuracion'
                className='text-white underline'
              >
                Configuración Cookies
              </Link>
              <Link to='/terminos-condiciones' className='text-white underline'>
                Términos & Condiciones
              </Link>
              <Link to='/politica-privacidad' className='text-white underline'>
                Política de Privacidad
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
